import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedLayout } from "./components/ProtectedLayout";
import { ToasterProvider } from "./components/toaster";
import { AuthProvider } from "./hooks/utility-hoks/useAuth";
import { UserImpersonationProvider } from "./hooks/utility-hoks/useUserImpersonation";
import Admin from "./views/admin/Admin";
import SitesAdmin from "./views/admin/sites-admin/SitesAdmin";
import NewUser from "./views/admin/user-admin/NewUser";
import UserAdmin from "./views/admin/user-admin/UserAdmin";
import Login from "./views/Login";
import Main from "./views/Main";
import Settings from "./views/Settings";
import UIShowRoom from "./views/UIShowRoom";

const App = () => {
  return (
    <ToasterProvider>
      <UserImpersonationProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedLayout />}>
              <Route path=":dashboardId" element={<Main />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/admin" element={<Admin />}>
                <Route index element={<Navigate to="users" replace />} />
                <Route path="users" element={<UserAdmin />} />
                <Route path="users/new" element={<NewUser />} />
                <Route path="sites" element={<SitesAdmin />} />
              </Route>
              <Route path="/ui-showroom" element={<UIShowRoom />} />
              <Route index element={<Navigate to="/live-data" />} />
            </Route>
          </Routes>
        </AuthProvider>
      </UserImpersonationProvider>
    </ToasterProvider>
  );
};

export default App;
